import React from "react";
import "../compents/Header.css";

const ReportTable = ({
  data,
  mainTitle,
  onDistrictClick,
  onBlockClick,
  isBlockTable = false,
  isFpsTable = false,
  onDownloadReport,
  onTotalClick,
  monthName,
  year,
  blockName,
}) => {
  if (!data || data.length === 0) {
    return (
      <p className="text-center mt-6 text-lg font-medium text-red-600">
        No Data Found
      </p>
    );
  }

  const headerText = isBlockTable
    ? "Block Name"
    : isFpsTable
    ? "FPS ID"
    : "District Name";

  const formatBlockName = (name) => {
    if (name && name.includes(",")) {
      return name.substring(name.indexOf(",") + 1).trim();
    }
    return name;
  };

  const total = {
    totalCards: data.reduce((sum, row) => sum + row.totalCards, 0),
    addition: data.reduce((sum, row) => sum + row.addition, 0),
    modification: data.reduce((sum, row) => sum + row.modification, 0),
    deletion: data.reduce((sum, row) => sum + row.deletion, 0),
  };

  const handleDownloadClick = () => {
    if (onDownloadReport) {
      onDownloadReport();
    }
  };

  const handleTotalRowClick = () => {
    if (onTotalClick) {
      if (
        window.confirm(
          "Do you want to download the full raw data for these totals?"
        )
      ) {
        onTotalClick();
      }
    }
  };

  let titleSuffix = isBlockTable
    ? `Block Wise`
    : isFpsTable
    ? `FPS Wise`
    : `District Wise`;

  if (blockName) {
    titleSuffix = `${blockName}, ${titleSuffix}`;
  }

  const baseTitle = mainTitle || "Report";
  const fullTitle = `${baseTitle}, ${titleSuffix} (${monthName} ${year})`;

  return (
    <div className="wrapper row3">
      <div id="container" className="w-full">
        <h1 className="tableheader py-2">{fullTitle}</h1>

        <table className="w-full">
          <thead className="">
            <tr className="tableheader">
              <th>Sl No.</th>
              <th>{headerText}</th>
              <th>Total Cards</th>
              <th>Addition</th>
              <th>Modification</th>
              <th>Deletion</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => (
              <tr key={index} className="tabledata text-end">
                <td className="text-center">{row.slNo}</td>
                {isFpsTable ? (
                  <td className="text-start">{row.fpsId}</td>
                ) : isBlockTable ? (
                  <td
                    style={{ textAlign: "left" }}
                    className={
                      onBlockClick
                        ? "text-blue-600 underline cursor-pointer"
                        : ""
                    }
                    onClick={() =>
                      onBlockClick &&
                      onBlockClick(row.distCode, row.officeCode, row.blockName)
                    }
                  >
                    {formatBlockName(row.blockName)}
                  </td>
                ) : (
                  <td
                    style={{ textAlign: "left" }}
                    className={
                      onDistrictClick
                        ? "text-blue-600 underline cursor-pointer"
                        : ""
                    }
                    onClick={() =>
                      onDistrictClick &&
                      onDistrictClick(row.distCode, row.districtName)
                    }
                  >
                    {row.districtName}
                  </td>
                )}
                <td>{row.totalCards}</td>
                <td>{row.addition}</td>
                <td>{row.modification}</td>
                <td>{row.deletion}</td>
              </tr>
            ))}

            <tr
              className="tableheader"
              style={{ cursor: onTotalClick ? "pointer" : "default" }}
              onClick={handleTotalRowClick}
              title={onTotalClick ? "Click to download full raw data" : ""}
            >
              <td colSpan="2">Total</td>
              <td className="underline">{total.totalCards}</td>
              <td className="underline">{total.addition}</td>
              <td className="underline">{total.modification}</td>
              <td className="underline">{total.deletion}</td>
            </tr>
          </tbody>
        </table>

        {onDownloadReport && (
          <div style={{ marginTop: "15px", textAlign: "center" }}>
            <button onClick={handleDownloadClick} className="button button2">
              Download Excel Report
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportTable;
